export default __webpack_public_path__ + "6773f5c31c5d09bc282d59c2e6030d2a.png";